<div class="rounded-xl shadow p-4 border border-gray-100 h-full">
  <ng-content></ng-content>
</div>
